import { DetailForm } from '@/@diffrag/form/DetailForm'
import { FormFieldType } from '@/@diffrag/form/fields/type'
import { useApi } from '@/@diffrag/hooks/useApi'
import { useQueryValue } from '@/@diffrag/hooks/useQueryValue'
import { ContentDetailView } from '@/@diffrag/layout/ContentDetailView'
import { api } from '@/api'
import { IAdminCommunityRO } from 'api'
import dayjs from 'dayjs'
import parse from 'html-react-parser'
import { useNavigate } from 'react-router-dom'
import { toast } from '@/lib/toast'

export default function CommunityEdit() {
  const id = useQueryValue('id', 0)
  const navigate = useNavigate()

  const { data } = useApi({
    id: 'communityDetail',
    fn: api().adminCommunity.getCommunityArticleDetail,
    params: id,
    enabled: !!id,
  })

  const onSave = async (formData: IAdminCommunityRO) => {
    await api().adminCommunity.updateCommunityArticle(formData.id, {
      excludeFromPopular: formData.excludeFromPopular,
    })
    toast.success('저장했습니다.')
    navigate('/community')
  }

  const onDelete = async () => {
    await api().adminCommunity.deleteCommunityArticle(id)
  }

  return (
    <ContentDetailView title="커뮤니티 상세" data={data} onSave={onSave} onDelete={onDelete}>
      <DetailForm
        data={data}
        fields={[
          {
            key: 'id',
            label: 'NO',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'board.title',
            label: '게시판',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'category.name',
            label: '카테고리',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'title',
            label: '제목',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'content',
            label: '상세내용',
            type: FormFieldType.CUSTOM_READ_ONLY,
            readOnly: true,
            render(data) {
              return <div>{parse(data?.content || '')}</div>
            },
          },
          {
            key: data?.author.clinic
              ? 'author.clinic.name'
              : 'author.userData.nickname',
            label: '작성자',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'createDate',
            label: '작성일',
            type: FormFieldType.STRING,
            readOnly: true,
            resolver: (row) => dayjs(row.createDate).format('YYYY-MM-DD'),
          },
          {
            key: 'viewCount',
            label: '조회수',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'bookmarkCount',
            label: '북마크수',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'commentCount',
            label: '댓글수',
            type: FormFieldType.STRING,
            readOnly: true,
          },
          {
            key: 'shareCount',
            label: '공유수',
            type: FormFieldType.STRING,
            readOnly: true,
            resolver: (row) => {
              const count1 = row.shareCountFacebook || 0
              const count2 = row.shareCountKakao || 0
              const count3 = row.shareCountTwitter || 0
              const count4 = row.shareCountUrl || 0
              const count5 = row.shareCountWechat || 0
              return `${count1 + count2 + count3 + count4 + count5}`
            },
          },
          {
            key: 'articleStatus',
            label: '상태',
            type: FormFieldType.STRING,
            readOnly: true,
            resolver: (row) =>
              row.articleStatus === 'VISIBLE' ? '노출중' : '비노출',
          },
          {
            key: 'excludeFromPopular',
            label: '인기글 제외',
            type: FormFieldType.CHECKBOX,
            required: false,
          },
        ]}
      />
    </ContentDetailView>
  )
}
